import 'animate.css'
import 'semantic-ui-css/semantic.css'
import 'semantic-ui-css/semantic.js'
import 'noty/lib/noty.css'
import moment from 'moment'
import Vue from 'vue'

import i18n from './i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import { rtdbPlugin } from 'vuefire'
import VueLocalStorage from 'vue-localstorage'
import VueImg from 'v-img'
import VueNoty from '@/plugins/Noty'
import VueKonva from 'vue-konva'
import VueApexCharts from 'vue-apexcharts'
import VueClipboard from 'vue-clipboard2'
import { getLocale } from './libs/util'

import './directives'
import './filters'

export default ({ firebase, validation, errorTracking, analytics }) => {
  const db = firebase.database()

  store.dispatch('setRef', ['access', db.ref('access')])
  store.dispatch('setRef', ['common', db.ref('common')])
  store.dispatch('setPlatform', window.device.platform)
  store.dispatch('purchases/init', { env: process.env.NODE_ENV })

  require('./handle-network')
  validation.init()

  window.moment = moment

  moment.updateLocale('en', {
    longDateFormat: { L: 'MM/DD/YY' }
  })
  moment.updateLocale('ko', {
    longDateFormat: { L: 'YY.MM.DD.' }
  })
  moment.locale(getLocale())

  let triedInitAuth = false

  window.StatusBar.overlaysWebView(false)

  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      store.dispatch('loggedIn', user)
    } else {
      store.dispatch('loggedOut')
    }

    if (!triedInitAuth) {
      initApp()
      triedInitAuth = true
    }
  })

  Vue.config.errorHandler = (err, vm, info) => {
    if (process.env.NODE_ENV !== 'production') {
      Vue.util.warn(`Error in ${info}: "${err.toString()}"`, vm)
    }
    console.error(err)
  }

  errorTracking.init()
  analytics.init()

  VueClipboard.config.autoSetContainer = true

  Vue.use(VueClipboard)
  Vue.use(VueApexCharts)
  Vue.use(VueLocalStorage, { name: 'ls' })
  Vue.use(rtdbPlugin)
  Vue.use(VueImg)
  Vue.use(VueKonva)
  Vue.use(VueNoty, { text: i18n.t('noty') })

  Vue.component('Apexchart', VueApexCharts)

  function initApp () {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      components: { App },
      created () {
        document.querySelector('.spinner').style.display = 'none'
      },
      template: '<App/>',
      i18n
    })
    /* eslint-enable no-new */
  }
}
